import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { MenuItemInput } from '../../shared/form/FormInput';
import { ProfileAvatar, RenderHeaderAppLogo, RenderHeaderText } from '../../shared/components/ConditonalComponent';
import { logout } from '../../shared/settings/auth';

// style imports
import './Header.scss';

const menuItem = {
    icon: <ProfileAvatar />,
    items: [
        {
            id: 5,
            label: 'Logout',
            type: 'menu'
        },
        {
            id:6,
            label: 'Terms and conditions',
            type: 'terms'
        }
    ]
};

const Header = (props) => {
    const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);
    const loggedInUserData = useSelector((state) => state.user );

    return (
        <div className="d-flex border-bottom header-box">
            <div className='w-100 d-flex position-relative'>

                <RenderHeaderText />

                <RenderHeaderAppLogo isSidebarOpen={isSidebarOpen} />
                
                <div className='d-flex align-items-center justify-content-end header-content-box'>
                    {
                        (loggedInUserData?.id && !props.location.pathname.includes("public")) && 
                        <div className='d-flex gap-2 gap-lg-3 justify-content-end px-3'>
                            {/* <Link className="d-flex align-items-center">
                                <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/question.png`} alt={"question"} />
                            </Link> */}
                            <MenuItemInput icon={menuItem.icon} items={menuItem.items} data={{}} onClick={(id) => {
                                switch (id) {
                                    case id:
                                        logout(props.history)
                                        break;

                                    default:
                                        break;
                                }
                            }} />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Header;
